import { Button, Modal } from 'antd';
import React from 'react';
import { CloseIcon } from '../../assets/icons';

/**
 *
 * @typedef {object} NoFundModalProps
 * @property {boolean} open
 * @property {()=>void} onClose
 * @property {()=>void} openTransferFunds
 * @param {NoFundModalProps} props
 */
export const NoFundModal = (props) => {
  const { open, onClose, openTransferFunds } = props;
  return (
    <Modal open={open} width={524} footer={false} closeIcon={<CloseIcon />} onCancel={onClose} maskClosable={false} centered>
      <div className='text-center mb-48 '>
        <h4 className='success__title mb-16 fw-500'>
          Transfer to your <strong>Realbricks</strong> wallet
        </h4>
        <p className='mb-24 text-taupe w-100'>You have to transfer funds to your Realbricks Wallet to make a purchase on the secondary market.</p>
      </div>

      <Button type='primary' className='ant-btn-primary--alt' block onClick={openTransferFunds}>
        Transfer Funds Now
      </Button>
    </Modal>
  );
};
